export const NOTIFICATIONS_STATE_UPDATE = 'CHAT/NOTIFICATIONS_STATE/UPDATE'
